// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import Utility from '../classes/Utility';
import { Controller } from "stimulus"
import axios from 'axios';
import Constants from '../classes/Constants';

export default class extends Controller {
  static targets = [
    'leftIllustration',
    'rightIllustration',
    'themeText'
  ]

  async retrieveCoupon(couponCode) {
    const res = await axios.get(`/api/coupon_validator/${couponCode}/`)
    const { data } = res;
    if (data.result) {
      return data.data.amount_off;
    } else {
      return false;
    }
  }

  codeToTheme(code) {
    let caseInsensitiveCode = code;
    let theme = 'default'
    if (code) {
      caseInsensitiveCode = code.toUpperCase();
    }
    Object.keys(Constants.couponThemes).some(themeKey => {
      const { regex } = Constants.couponThemes[themeKey];
      if (regex && regex.test(caseInsensitiveCode)) {
        theme = themeKey;
        return true
      }
      return false
    })
    return theme;
  }

  async connect() {
    try {
      const params = new URLSearchParams(window.location.search);
      // Retrieves coupon from url param or
      // cookie value
      if (params.has('coupon')) {
        Utility.setLocalCookies('coupon_code', params.get('coupon'));
        this.coupon = params.get('coupon');
      } else {
        this.coupon = Utility.getCookie('coupon_code');
      }
      if (this.coupon != 'unknown') {
        const priceOff = await this.retrieveCoupon(this.coupon);
        if (priceOff) {
          const themeCode = this.codeToTheme(this.coupon);
          const theme = Constants.couponThemes[themeCode];
          if (themeCode !== 'default') {
            // Show the coupon theme text box
            this.element.classList.remove('t-hidden');
            this.element.classList.add('t-flex');
            // Add theme to text
            this.themeTextTarget.textContent = `Get $${priceOff} off your purchase`;
            this.themeTextTarget.style.color = theme.textColor;
            const leftIllElement = document.createElement('img');
            const rightIllElement = document.createElement('img');
            leftIllElement.src = theme.illustrationLeft.src;
            rightIllElement.src = theme.illustrationRight.src;
            this.leftIllustrationTarget.appendChild(leftIllElement);
            this.rightIllustrationTarget.appendChild(rightIllElement);
          }
        }
      }
    } catch(e) {
      console.log(e)
    }
  }

}
